/**
 * This duplicates the functionality of timeframe-label but with greater formatting flexibility
 *
 * TODO: Pass date as parameter instead of using rootScope
 */
angular.module('EdxCommonModule')
  .directive("edxTimeframeDisplay", function() {
    return {
      restrict: "E",
      scope: {
      },
      templateUrl: '/resources/components/common/timeframe-display/timeframe-display.component.html',
      controller: ['$rootScope', 'edxDateTimeService', function($rootScope, dateTimeService) {
        var vm = this;
        vm.dayOfWeek = dayOfWeek;

        vm.format = 'longDate';

        /**
         * Returns 3 character abbreviation for the day of the week, or "Today" if date is today
         *
         * @param date
         * @return {string}
         */
        function dayOfWeek(date) {
          return dateTimeService.dayOfWeekOrToday(date);
        }

        $rootScope.$watch('reportDates', function(newValue) {
          if (newValue) {
            vm.fromDate = newValue.from_date;
            vm.toDate = newValue.to_date;
            vm.fromAndToAreEqual = (vm.fromDate === vm.toDate) ? true : false;
          } else {
            vm.fromDate = undefined;
            vm.toDate = undefined;
          }
        });
      }],
      controllerAs: 'vm',
      bindToController: true
    };
  });
